import React, { Suspense, useEffect, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from 'hooks';
import { rubricActions } from 'store/rubric/rubricSlice';
import Loader from 'Components/Loader';

import { selectPartnerData } from 'store/partner/partnerSelector';
import sortRubrics from 'Utils/Rubric/sortRubrics';
import { RubricsStatus, useGetRubricsQuery } from 'generated/graphql';

interface RubricLoaderProps {
    children: React.ReactNode;
}

const ScorecardLoader: React.FC<RubricLoaderProps> = ({ children }) => {
    const dispatch = useAppDispatch();

    const { instanceId } = useAppSelector(selectPartnerData);
    const { data, loading } = useGetRubricsQuery({
        variables: { instanceId }
    });

    const rubrics = useMemo(() => data?.getRubrics || [], [data])

    useEffect(() => {
        if (rubrics) {
            const sortedRubrics = sortRubrics(rubrics);

            dispatch(rubricActions.SAVE_RUBRICS(sortedRubrics));

            const savedRubricId = window.localStorage.getItem(
                `selectedRubricId_${instanceId}`,
            );

            const savedRubric = sortedRubrics.find(
                ({ id, status }) =>
                    savedRubricId === id && status === RubricsStatus.Published,
            );

            if (savedRubric) {
                dispatch(rubricActions.SAVE_RUBRIC_ID(savedRubric.id));
            } else dispatch(rubricActions.SAVE_RUBRIC_ID(null));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);

    if (loading) return <Loader message="Fetching scorecards" />;

    return <>{children}</>;
};

export default ScorecardLoader;
